import React, { useState, useEffect, useCallback, useMemo } from "react";
import "../styles/home.css";
import NewBooks from "../HomeComponents/NewBooks";
import EventSlider from "../HomeComponents/EventsSlider";
import News from "../HomeComponents/News";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faIdCard,
  faQuestion,
  faUser,
  faBookOpen,
  faBookOpenReader,
  faSearch,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import AnnouncementPage from "../HomeComponents/AnnouncementPage";
import IsilCard from "../HomeComponents/IsilCard";
import ImageSlider from "../HomeComponents/ImageSlider";
import SearchDialog from "../HomeComponents/SearchDialog";
import { useLanguage } from "../../contexts/LanguageContext";

const translations = {
  kz: {
    electronicCatalog: "Электрондық каталог",
    getReaderCard: "Оқырман билетін алу",
    questions: "Кітапханашыға сұрақ",
    directorBlog: "Директор блогы",
    electronicLibrary: "Электрондық кітапхана",
    newArrivals: "Жаңа түсімдер",
    searchPlaceholder: "Кітапханадан іздеу...",
  },
  ru: {
    electronicCatalog: "Электронный каталог",
    getReaderCard: "Получить читательский билет",
    questions: "Вопрос библиотекарю",
    directorBlog: "Блог директора",
    electronicLibrary: "Электронная библиотека",
    newArrivals: "Новые поступления",
    searchPlaceholder: "Поиск по библиотеке...",
  },
  en: {
    electronicCatalog: "Electronic Catalog",
    getReaderCard: "Get Reader Card",
    questions: "Question for the librarian",
    directorBlog: "Director's Blog",
    electronicLibrary: "Electronic Library",
    newArrivals: "New Arrivals",
    searchPlaceholder: "Search the library...",
  },
};

const actions = [
  { key: 'electronicCatalog', icon: faBookOpen, onClick: 'catalog' },
  { key: 'getReaderCard', icon: faIdCard, onClick: 'register', primary: true },
  { key: 'electronicLibrary', icon: faGlobe, onClick: 'library' },
  { key: 'newArrivals', icon: faBookOpenReader, onClick: 'books' },
  { key: 'questions', icon: faQuestion, onClick: 'questions' },
  { key: 'directorBlog', icon: faUser, onClick: 'blog' },
];

function Home() {
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  const { currentLanguage } = useLanguage();

  const t = useMemo(
    () => translations[currentLanguage] || translations.ru,
    [currentLanguage]
  );

  const handleClick = useCallback((type) => {
    switch (type) {
      case 'catalog':
        window.location.href = "http://82.200.245.21:7980";
        break;
      case 'register':
        navigate("/register");
        break;
      case 'library':
        window.open("https://kazneb.kz", "_blank", "noopener,noreferrer");
        break;
      case 'books':
        navigate("/books");
        break;
      case 'questions':
        navigate("/questions");
        break;
      case 'blog':
        navigate("/blog-director");
        break;
      default:
        break;
    }
  }, [navigate]);

  return (
    <div>
      <div className="section-one">
        <div className="hero-inner">
          <div
            className="search-bar-trigger"
            onClick={() => setSearchOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setSearchOpen(true);
              }
            }}
            aria-label="Поиск по библиотеке"
          >
            <FontAwesomeIcon icon={faSearch} className="search-bar-trigger-icon" />
            <span className="search-bar-trigger-text">
              {t.searchPlaceholder || 'Поиск по библиотеке...'}
            </span>
            <span className="search-bar-trigger-hint">
              {currentLanguage === 'kz' ? 'Іздеу' : currentLanguage === 'en' ? 'Search' : 'Поиск'}
            </span>
          </div>

          <div className="action-bar">
            {actions.map((action) => (
              <div
                key={action.key}
                className={`action-btn${action.primary ? ' action-btn-primary' : ''}`}
                onClick={() => handleClick(action.onClick)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick(action.onClick);
                  }
                }}
                aria-label={t[action.key]}
              >
                <span className="action-btn-icon">
                  <FontAwesomeIcon icon={action.icon} />
                </span>
                <span className="action-btn-label">{t[action.key]}</span>
                <span className="action-btn-arrow">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="home-information">
        <AnnouncementPage />
        <IsilCard />
      </div>
      <EventSlider />
      <News />
      <NewBooks />
      <ImageSlider />

      {searchOpen && <SearchDialog isOpen={searchOpen} onClose={() => setSearchOpen(false)} />}
    </div>
  );
}

export default Home;
